import { utils as dataUtils } from '@easydata/core';
import { Query } from '../query/query';
var BrowserQueryStorage = /** @class */ (function () {
    function BrowserQueryStorage(context) {
        this.context = context;
        console.warn('BrowserQueryStorage is used for managing queries');
    }
    BrowserQueryStorage.prototype.init = function (options) {
        var keyPrefix = 'eq';
        if (options && options.keyPrefix) {
            keyPrefix = options.keyPrefix;
        }
        this.queryListKey = keyPrefix + '-querylist';
        this.queryKeyPrefix = keyPrefix;
    };
    BrowserQueryStorage.prototype.getQueryList = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var itemsString = localStorage.getItem(_this.queryListKey);
                if (itemsString) {
                    resolve(JSON.parse(itemsString));
                }
                resolve([]);
            }
            catch (err) {
                reject(err);
            }
            ;
        });
    };
    BrowserQueryStorage.prototype.newQuery = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var query = new Query(_this.context.getModel());
            query.reset();
            query.setDefaultName();
            if (options) {
                if (options.query) {
                    query.loadFromData(options.query.toJSONData());
                }
                if (options.queryId) {
                    query.setId(options.queryId);
                }
                if (options.name) {
                    query.setName(options.name);
                }
                if (options.description) {
                    query.setDescription(options.description);
                }
            }
            _this._saveQuery(query);
            resolve(query.toJSONData());
        });
    };
    BrowserQueryStorage.prototype.loadQuery = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var queryItem = localStorage.getItem(_this.queryKeyPrefix + '-' + options.queryId);
                if (queryItem) {
                    resolve(JSON.parse(queryItem));
                }
                throw new Error('Query is not found: ' + options.queryId);
            }
            catch (err) {
                reject(err);
            }
        });
    };
    BrowserQueryStorage.prototype.saveQuery = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var modelId = options.modelId || _this.context.getModel().getId();
                var query = options.query || _this.context.getQuery();
                _this._saveQuery(query);
                resolve(null);
            }
            catch (err) {
                reject(err);
            }
        });
    };
    BrowserQueryStorage.prototype._saveQuery = function (query) {
        var queryList = [];
        var itemsString = localStorage.getItem(this.queryListKey);
        if (itemsString) {
            queryList = JSON.parse(itemsString);
        }
        var item = dataUtils.findItemById(queryList, query.getId());
        if (!item) {
            item = { id: query.getId(), name: query.getName(), text: query.getDescription() };
            queryList.push(item);
        }
        item.name = query.getName();
        item.text = query.getDescription();
        localStorage.setItem(this.queryListKey, JSON.stringify(queryList));
        localStorage.setItem(this.queryKeyPrefix + '-' + query.getId(), query.toJSON());
    };
    BrowserQueryStorage.prototype.removeQuery = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var modelId = options.modelId || _this.context.getModel().getId();
                var queryId_1 = options.queryId || _this.context.getQuery().getId();
                var queryList = [];
                var itemsString = localStorage.getItem(_this.queryListKey);
                if (itemsString) {
                    queryList = JSON.parse(itemsString);
                }
                queryList = queryList.filter(function (item) { return item.id != queryId_1; });
                localStorage.setItem(_this.queryListKey, JSON.stringify(queryList));
                localStorage.removeItem(_this.queryKeyPrefix + '-' + queryId_1);
                resolve();
            }
            catch (err) {
                reject(err);
            }
        });
    };
    return BrowserQueryStorage;
}());
export { BrowserQueryStorage };
//# sourceMappingURL=query_storage.js.map